export default __webpack_public_path__ + "static/media/send-survey-gif.2fd0c516.gif";